"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var utils_1 = require("../../utils");
var Box_1 = require("../Box");
var Button_1 = require("../Button");
var TableCell_1 = require("../TableCell");
var ExpanderCell = function (_a) {
    var context = _a.context, expanded = _a.expanded, onToggle = _a.onToggle, theme = _a.theme, rest = tslib_1.__rest(_a, ["context", "expanded", "onToggle", "theme"]);
    var ExpandIcon = theme.dataTable.icons[expanded ? 'contract' : 'expand'];
    if (onToggle) {
        return (React.createElement(TableCell_1.TableCell, { size: "xxsmall", plain: true, verticalAlign: "top" },
            React.createElement(Button_1.Button, { plain: true, fill: true, a11yTitle: expanded ? 'collapse' : 'expand', hoverIndicator: true, disabled: !onToggle, onClick: onToggle },
                React.createElement(Box_1.Box, tslib_1.__assign({}, tslib_1.__assign(tslib_1.__assign({}, theme.table[context]), theme.dataTable[context]), rest, { align: "center", pad: "xxsmall" }),
                    React.createElement(ExpandIcon, { color: utils_1.normalizeColor('border', theme) })))));
    }
    return React.createElement(TableCell_1.TableCell, { size: "xxsmall", verticalAlign: "top" });
};
var ExpanderCellWrapper = recompose_1.compose(styled_components_1.withTheme)(ExpanderCell);
exports.ExpanderCell = ExpanderCellWrapper;
//# sourceMappingURL=ExpanderCell.js.map